export default function TypingIndicator() {
  return (
    <div className="flex items-end gap-2">
      <div className="flex max-w-[70%] flex-col items-start">
        <div className="rounded-card border border-line bg-surface px-4 py-3">
          <div className="flex gap-1">
            <span className="h-2 w-2 animate-bounce rounded-full bg-ink-3" style={{ animationDelay: '0ms' }} />
            <span className="h-2 w-2 animate-bounce rounded-full bg-ink-3" style={{ animationDelay: '150ms' }} />
            <span className="h-2 w-2 animate-bounce rounded-full bg-ink-3" style={{ animationDelay: '300ms' }} />
          </div>
        </div>
        <span className="mt-1 text-xs text-ink-3">Typing...</span>
      </div>
    </div>
  );
}
